import { NgForOf } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { BtwChartModule } from '@between/ng-cdk/chart';
import { Guid } from 'guid-typescript';
import { BtwDatePipe } from '@between/ng-common';
import { IIndicatorStorageDto } from 'src/app/api-services/indicator-api/indicator-api.interfaces';
import { AnalysisApiService } from 'src/app/api-services/analysis-api/analysis-api.service';

@Component({
  selector: 'stacked-indicator-analysis',
  standalone: true,
  imports: [NgForOf, BtwChartModule, BtwDatePipe],
  templateUrl: './stacked-indicator-analysis.component.html',
  styleUrl: './stacked-indicator-analysis.component.scss'
})
export class StackedIndicatorAnalysisComponent implements OnInit {
  private readonly analysisApiService: AnalysisApiService = inject(AnalysisApiService);

  @Input({ required: true })
  analysisId!: Guid;

  @Input({ required: true})
  indicatorName!: string;

  @Input()
  description: string | undefined;

  series: string[] = [];
  dataSource: any[] = [];

  showCharts: boolean = false;

  ngOnInit(): void {
    this.analysisApiService.getIndicatorPerAnalysisId(this.indicatorName, this.analysisId).subscribe({
      next: (response: IIndicatorStorageDto[]) => {
        this.setDataSource(response);
        this.showCharts = true;
      }
    });
  }

  private setDataSource(data: IIndicatorStorageDto[]): void {
    const allNames: string[] = data.flatMap(item => item.specificIndicatorValues.map(indicator => indicator.name));
    this.series = [...new Set(allNames)];

    this.dataSource = data.map(item => {
      const emtpyDatasourceItem: {[key: string]: number | null} = {};
      
      this.series.forEach(serie => {
          emtpyDatasourceItem[serie] = null;
      });
  
      const filledDatasourceItem = Object.assign(emtpyDatasourceItem, item.specificIndicatorValues.reduce((obj, item) => Object.assign(obj, { [item.name]: item.value }), {}));
  
      return Object.assign({ date: item.date }, filledDatasourceItem);
    });
  }
}
